import { render, staticRenderFns } from "./Banner2.vue?vue&type=template&id=698e7498&scoped=true&"
import script from "./Banner2.vue?vue&type=script&lang=js&"
export * from "./Banner2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698e7498",
  null
  
)

export default component.exports